<script>
import { mapActions } from "vuex";
import Modal from "@/components/_Shared/Modal";
import InputGroup from "@/components/_Shared/InputGroup";

export default {
  props: {
    city_id: {
      type: String,
      required: true
    }
  },
  components: {
    Modal,
    InputGroup
  },
  data() {
    return {
      preloader: false,
      district: {
        display_name: "",
        code: "",
        rating: {
          rating_min: 20,
          rating_max: 100
        },
        pricing: {
          price: 0,
          price_per_hour: 0,
          price_percentage: 0,
          fee: 0,
          fee_per_hour: 0,
          fee_percentage: 0
        }
      },
      rating_min: 1,
      rating_max: 5
    };
  },
  methods: {
    ...mapActions("districts", ["create"]),

    ratingToPercentage(rating, value = 5) {
      return (rating * 100) / value;
    },

    async submit() {
      this.preloader = true;

      try {
        let valid = await this.$validator.validateAll();

        if (valid) {
          let data = {
            city_id: this.city_id,
            district: this.district
          };

          let res = await this.create(data);

          if (res) {
            this.$emit("close");
            this.$emit("refresh");
          }
        }
      } catch (e) {
        this.$toast.error(e);
      }

      this.preloader = false;
    }
  },

  watch: {
    rating_min(val) {
      this.district.rating.rating_min = this.ratingToPercentage(val);
    },

    rating_max(val) {
      this.district.rating.rating_max = this.ratingToPercentage(val);
    }
  }
};
</script>

<template>
  <modal
    title="NOVO DISTRITO"
    subtitle="Informe os dados do novo distrito"
    size="md"
    @close="$emit('close')"
  >
    <template slot="body">
      <div class="form-group">
        <InputGroup
          :error="errors.first('nome')"
          v-validate.disabled="'required'"
          v-model="district.display_name"
          label="nome"
        />

        <InputGroup
          :error="errors.first('codigo')"
          v-validate.disabled="'required|max:3'"
          v-model="district.code"
          label="codigo"
        />
      </div>

      <div class="title-form mt-30">NOTAS</div>

      <div class="form-group">
        <InputGroup
          :error="errors.first('nota mínima')"
          type="number"
          v-validate.disabled="'required|min_value:1|max_value:5'"
          v-model="rating_min"
          label="nota mínima"
        />

        <InputGroup
          :error="errors.first('nota máxima')"
          type="number"
          v-validate.disabled="'required|min_value:1|max_value:5'"
          v-model="rating_max"
          label="nota máxima"
        />
      </div>

      <div class="title-form mt-30">PREÇOS</div>

      <div class="form-group">
        <InputGroup
          :error="errors.first('preço')"
          type="money"
          v-validate.disabled="'required|min_value:0'"
          v-model="district.pricing.price"
          label="preço"
        />

        <InputGroup
          :error="errors.first('preço por hora')"
          type="money"
          v-validate.disabled="'required|min_value:0'"
          v-model="district.pricing.price_per_hour"
          label="preço por hora"
        />
      </div>

      <div class="form-group">
        <InputGroup
          :error="errors.first('taxa')"
          type="money"
          v-validate.disabled="'required|min_value:0'"
          v-model="district.pricing.fee"
          label="taxa"
        />

        <InputGroup
          :error="errors.first('taxa por hora')"
          type="money"
          v-validate.disabled="'required|min_value:0'"
          v-model="district.pricing.fee_per_hour"
          label="taxa por hora"
        />
      </div>
    </template>

    <template slot="footer">
      <v-btn @click="$emit('close')">fechar</v-btn>
      <v-btn
        class="btn bg-purple"
        :class="{ 'btn--loading': preloader }"
        @click="submit"
      >
        <span>cadastrar</span>
      </v-btn>
    </template>
  </modal>
</template>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/Cities/NewDistrict.vue